import React from 'react'
import {
  BorderStyle,
  Box,
  Color,
  Display,
  FontWeight,
  JustifyContent,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

const onSpaceOrEnter =
  (callback: (event: React.KeyboardEvent) => void) => (event: React.KeyboardEvent) => {
    if (event.code === 'Space' || event.code === 'Enter') {
      event.preventDefault()
      callback(event)
    }
  }

const CustomButton = withCitrusTheme(Box, (theme) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.color(Color.Transparent),
  border: 'none',
  minHeight: theme.spacing(12),
  width: 'min(33.33%, 12rem)',
  cursor: 'pointer',
  '& *': {
    whiteSpace: 'nowrap',
  },
  '&[aria-selected="true"]': {
    borderBottom: `5px solid ${theme.color(Color.Secondary_400)}`,
  },
}))

export type NavBarButtonProps = {
  text: string
  onClick: () => void
  selected?: boolean
  slug?: string
}

const NavBarButton = ({ text, onClick, selected, slug }: NavBarButtonProps) => {
  return (
    <CustomButton
      role="tab"
      justifyContent={JustifyContent.Center}
      onClick={onClick}
      onKeyDown={onSpaceOrEnter(onClick)}
      data-slug={slug}
      aria-selected={selected}
      tabIndex={0}
    >
      <Text
        color={selected ? Color.Secondary_400 : Color.ColdGrey_900}
        fontWeight={FontWeight.Bold}
        size={4}
      >
        {text}
      </Text>
    </CustomButton>
  )
}

export type NavBarProps = {
  links: NavBarButtonProps[]
}

export const NavBar = ({ links }: NavBarProps) => {
  return (
    <Box
      data-test-id="nav-bar-menu-page"
      bg={Color.White}
      borderStyle={BorderStyle.Solid}
      borderColor={Color.ColdGrey_100}
      borderBottomWidth={0.5}
    >
      <Box
        maxWidth="1600px"
        role="tablist"
        display={Display.Flex}
        justifyContent={[JustifyContent.SpaceBetween, JustifyContent.FlexStart]}
        paddingH={[0, 4, 8]}
        style={{ margin: '0 auto' }}
      >
        {links?.map((link, i) => (
          <NavBarButton
            slug={link.slug}
            selected={link.selected}
            key={i}
            text={link.text}
            onClick={link.onClick}
          />
        ))}
      </Box>
    </Box>
  )
}
